import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationToast from './NotificationToast';

const NotificationContainer = () => {
  const { toastNotifications, removeToastNotification, acknowledgeNotification } = useNotifications();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-3 pointer-events-none">
      {toastNotifications.map((notification, index) => (
        <div
          key={notification.toastId}
          className="pointer-events-auto"
          style={{
            marginTop: index > 0 ? '12px' : '0px',
            zIndex: 1000 - index,
          }}
        >
          <NotificationToast
            notification={notification}
            onClose={() => removeToastNotification(notification.toastId)}
            onAcknowledge={acknowledgeNotification}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;